<div style="height: 100%;">
  <agm-map style="height: 100%;" [latitude]="centerMaplat" [longitude]="centerMaplon" (centerChange) ="mapCenterChange($event)" (idle)="mapCenterChanged()" [zoom]="zoom"
    [disableDefaultUI]="false" [zoomControl]="true" (mapClick)="mapClicked($event)">
    <agm-marker *ngFor="let m of markers; let i = index" (markerDblClick)="clickedMarker(m)" [latitude]="m.lat"
      [longitude]="m.lng" [label]="m.label" [iconUrl]="m.iconUrl" [markerDraggable]="m.draggable"
      (dragEnd)="markerDragEnd(m, $event)" [visible]="m.visible" >
      <agm-info-window>
        {{m.interventoObject.nome}} <br>
        {{m.interventoObject.data_inizio_prevista }} <br>
        {{m.interventoObject.clienteObject.nominativo}} <br>
        {{m.interventoObject.sedeObject.fullAddress}} <br>
        {{m.interventoObject.sedeObject.distanza || 0 }} Km
      </agm-info-window>
    </agm-marker>
    <agm-circle *ngIf="hasCircle"
     [latitude]="circle.latitude"
     [longitude]="circle.longitude"
     [radius]="circle.radius"
     [fillColor]="circle.fillColor"
     [circleDraggable]="circle.circleDraggable"
     [editable]="circle.editable"
     [usePanning]="true"
     (centerChange)="circleMarkerCenterChange($event)"
     (radiusChange)="rangeCircleMarkerChanged($event)"
     (circleClick)= "clickedCircleMarker($event)"
     (dragEnd)="circleMarkerDragEnd()">
    </agm-circle>
  </agm-map>
</div>
